import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const SSitemap = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const SubList = styled.div`
padding: 0 3rem;
column-count: 4;
column-gap: 20px;
`;


const Sitemap = () => {
  return (
    <SSitemap>
      <h5>Mapa serwisu</h5>
      <ul>
        <b>testy</b>
        <li>
          <Link to="/test">typy testów</Link> - informacje o dostępnych testach
        </li>
      </ul>
      <ul>
        <b>język</b>
        <li>
          <Link to="/grammar">gramatyka</Link> - repetytorium z gramatyki języka
          hiszpańskiego
        </li>
        <SubList>
          <li><Link to="/grammar/introducion">wprowadzenie</Link></li>
          <li><Link to="/grammar/alfabeto">alfabet</Link></li>
          <li><Link to="/grammar/articulos">rodzajniki</Link></li>
          <li><Link to="/grammar/adjetivos">przymiotniki</Link></li>
          <li><Link to="/grammar/numerales">liczebniki</Link></li>
          <li><Link to="/grammar/pronombres">zaimki</Link></li>
          <li><Link to="/grammar/adverbios">przysłówki</Link></li>
          <li><Link to="/grammar/preposiciones">przyimki</Link></li>
          <li><Link to="/grammar/indicativo">tryb oznajmujący</Link></li>
          <li><Link to="/grammar/subjuntivo">tryb łączący</Link></li>
          <li><Link to="/grammar/condicional">tryb przypuszczający</Link></li>
          <li><Link to="/grammar/imperativo">tryb rozkazujący</Link></li>
          <li><Link to="/grammar/perifrasis">wyrażenia czasownikowe</Link></li>
          <li><Link to="/grammar/serestarhaber">ser/estar/haber</Link></li>
          <li><Link to="/grammar/condicionales">zdania warunkowe</Link></li>
          <li><Link to="/grammar/indirecto">mowa zależna</Link></li>
          <li><Link to="/grammar/pasiva">strona bierna</Link></li>
          <li><Link to="/grammar/temporales">zdania czasowe</Link></li>
        </SubList>
        <li><Link to="/idiom">idiomy</Link> - lista różnych ciekawych idiomów</li>
        <li><Link to="/phrase">zwroty</Link> - kilkadziesiąt zwrotów i wyrażeń przysłówkowych i spójnikowych</li>
        <li><Link to="/lang">o języku</Link> - graść informacji o języku hiszpańskim i językach pokrewnych</li>
      </ul>
      <ul>
        <b>zasoby</b>
        <li><Link to="/dict">słownik</Link> - prosty słownik z podziałem na kategorie tematyczne</li>
        <li><Link to="/verb">baza czasowników</Link> - ok. 300 czasowników wraz z koniugacją (możliwość regularnej koniugacji czasownika, którego nie ma w bazie)</li>
        <li><Link to="/proverb">przysłowia</Link> po hiszpańsku</li>
        <li><Link to="/template">wzory podań/listów</Link> - kilka wzorów listów</li>
      </ul>
      <ul>
        <b>katalogi</b>
        <li><Link to="/www">strony www</Link> - kilkanaście adresów stron wartych odwiedzenia</li>
        <li><Link to="/books">książki</Link> - informacje o książkach pomocnych w nauce hiszpańskiego</li>
        <li><Link to="/music">muzyka</Link> - teksty różnych piosenek, hymnu Hiszpanii itp.</li>
        <li><Link to="/poetry">poezja</Link> - wiersze mniej lub bardziej znanych poetów</li>
      </ul>
      <ul>
        <b>o EPT</b>
        <li><Link to="/about">o serwisie</Link> - kilka słów informacji o Español Para Todos, dane kontaktowe</li>
        <li><Link to="/sitemap">mapa serwisu</Link> - strona, na której obecnie się znajdujesz :)</li>
      </ul>
    </SSitemap>
  );
};

export default Sitemap;
